import api from 'api';
import coreApi from 'api/coreApi';
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { coreDomain, domain, tokenName } from 'services/config';
import preRequest from 'services/request';
import { camelizeKeys } from 'humps';
import Cookies from 'universal-cookie';

const requestInterceptor = async (config: AxiosRequestConfig) => {
  const cookieHeader = config.headers?.cookie;
  const cookies = cookieHeader ? new Cookies(String(cookieHeader)) : new Cookies();
  await preRequest(cookies);
  const token = cookies.get(tokenName);
  const authConfig =
    token !== ''
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {};
  return {
    ...config,
    headers: {
      ...config.headers,
      ...authConfig,
    },
  };
};

const responseInterceptor = (response: AxiosResponse) => {
  response.data = camelizeKeys(response.data);
  return response;
};

export const setAxiosInterceptors = ({
  instance,
  domain,
}: {
  instance: AxiosInstance;
  domain: string;
}): AxiosInstance => {
  instance.defaults.baseURL = domain;

  instance.interceptors.request.use(requestInterceptor);
  instance.interceptors.response.use(responseInterceptor);

  return instance;
};

export const run = () => {
  setAxiosInterceptors({ instance: api, domain: domain });
  setAxiosInterceptors({ instance: coreApi, domain: coreDomain });
};

export default {
  run,
};

export const apiWithInterceptors = setAxiosInterceptors({ instance: api, domain: domain });
export const coreApiWithInterceptors = setAxiosInterceptors({
  instance: coreApi,
  domain: coreDomain,
});
